import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/store/auth'
import { useFeatureFlag } from '@/hooks/useFeatureFlags'
import { isStandalonePWA } from '@/utils/pwa'
import { persistPwaSession } from '@/api/session'

/**
 * usePwaPersistentSession — no boot do PWA instalado, pede ao servidor p/ marcar
 * a sessão atual como longa (~10a). Best-effort, 1× por montagem. No-op fora do
 * PWA, sem auth, ou com a flag desligada.
 */
export function usePwaPersistentSession(): void {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const flag = useFeatureFlag('pwa_persistent_session')
  const done = useRef(false)

  useEffect(() => {
    if (done.current) return
    if (!isAuthenticated || !flag || !isStandalonePWA()) return
    done.current = true
    void persistPwaSession().catch(() => {
      // best-effort: falha não bloqueia; re-tenta no próximo boot
      done.current = false
    })
  }, [isAuthenticated, flag])
}
